import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { addressDrawerSelectCustomerContainerStyles } from "@dana/Overrides/Widgets/Header/AddressDrawerSelectCustomerContainer";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

addressDrawerSelectCustomerContainerStyles.container = mergeToNew(
    addressDrawerSelectCustomerContainerStyles.container,
    {
        width: [12, 12, 12, 12, 12],
        css: css``,
    },
);

addressDrawerSelectCustomerContainerStyles.billToGridItemFulfillmentLabel = mergeToNew(
    addressDrawerSelectCustomerContainerStyles.billToGridItemFulfillmentLabel,
    {
        width: 12,
        css: css`
            background: ${themeBackgrounds.lightGray};
            margin: 15px!important;
        `,
    },
);


